import axios from "axios";
import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import Breadcrumbs from "../../component/breadcrumbs";
import CustomHelmet from "../../component/CustomHelmet";
import Form from "../../component/Form";
import FormInput from "../../component/FormInput";
import Intro from "../../component/Intro";
import BaseContainer from "../../component/layout/base-container";

export default function PasswordChange() {
  const navigate = useNavigate();

  const params = useParams();
  const token = params.token;

  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  return (
    <>
      <CustomHelmet pageTitle="Passwort Ändern" />
      <Breadcrumbs
        listItems={[
          { name: "Home", url: "/" },
          { name: "Passwort vergessen", url: "/passwort" },
          { name: "Ändern", url: `/passwort/${token}` },
        ]}
      />

      <BaseContainer>
        <Intro title="Passwort ändern" />
        <p>Bitte geben Sie Ihr neues Passwort an. Passwort</p>
        <Form>
          <FormInput
            label="Passwort"
            type={showPassword ? "text" : "password"}
            required
            onInput={(e) => setPassword(e.target.value)}
          />
          <button onClick={() => setShowPassword((prevState) => !prevState)}>
            {showPassword ? "Passwort verstecken" : "Passwort anzeigen"}
          </button>
          <FormInput
            label="Passwort bestätigen"
            type="password"
            required
            onKeyUp={(e) => setPasswordConfirm(e.target.value)}
          />
          <div className="FormButtons">
            <button
              disabled={!(password && passwordConfirm)}
              className="Button color-primary size-large mb-8"
              style={{
                marginRight: "unset",
                marginLeft: "auto",
                ...(!(password && passwordConfirm) && {
                  backgroundColor: "rgba(var(--c-grey-light),1)",
                  color: "rgba(var(--c-black),0.6)",
                }),
              }}
              onClick={async () => {
                await axios.post(
                  `${process.env.REACT_APP_BASE_URL}password_reset/confirm/`,
                  { token: token, password: password }
                );

                navigate("/anmelden", {
                  state: {
                    message:
                      "Ihr Passwort wurde geändert, bitte melden Sie sich mit Ihrer E-Mail-Adresse und dem soeben gesetzen Passwort an.",
                  },
                });
              }}
            >
              Registrieren
            </button>
          </div>
        </Form>
      </BaseContainer>
    </>
  );
}
